import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import { ICommunity } from 'mhbo-js'
import React from 'react'
import { IntlProvider } from 'react-intl'
import NO_PHOTO from '../../../assets/no_photo.png'

interface IProps {
  dealerListing: ICommunity
  onClick: () => void
  onMouseOver?: () => void
  onMouseOut?: () => void
  isLazy: boolean
}

const DealerPreviewCell: React.FC<IProps> = (props: IProps) => {
  const { dealerListing, onMouseOver, onClick, isLazy } = props
  const { photoLarge, url, name, contact } = dealerListing
  const { name: contactName = '', lastName = '', daytimePhone = '' } = contact
  const photo = photoLarge === '' ? NO_PHOTO : photoLarge
  return (
    <IntlProvider locale="en">
      <div>
        <div>
          <div className="dealerPreviewCell__chip">dealer</div>
        </div>
        <div className="listingCell__preview_cell_header_common">
          <div className="dealerPreviewCell__name">{name}</div>
          <a
            className="dealerPreviewCell__more"
            href={url}
            target="_blank"
            rel="noreferrer"
          >
            <span>MORE</span>
            <KeyboardArrowRight />
          </a>
        </div>
        <img
          className="listingCell__preview_cell_image"
          onMouseOver={onMouseOver}
          onClick={onClick}
          src={photo}
          alt=""
          loading={isLazy ? 'lazy' : 'eager'}
        />
        <div className="dealerPreviewCell__contact">
          <span>CONTACT</span>
          {`   ${daytimePhone} ${contactName} ${lastName ? lastName : ''}`}
        </div>
      </div>
    </IntlProvider>
  )
}

export default DealerPreviewCell
